import React from 'react';
import { Typography, Button, Grid } from '@material-ui/core';
import { Edit as EditIcon } from '@material-ui/icons';
import { useSelector } from 'react-redux';

const BasicConfigurationWidget = ({
  currentSurvey,
  assessmentStatus,
  getSurveyTypeName,
  handleEditClick,
  classes,
}) => {
  const { en: { instantSurvey } } = useSelector((state) => state.i18n);

  return (
    <div className={`${classes.section} ${assessmentStatus === 'archived' ? classes.sectionArchived : ''}`}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 16,
      }}>
        <Typography className={classes.sectionTitle}>
          {instantSurvey.basicConfigTitle}
        </Typography>
        {assessmentStatus !== 'archived' && (
          <Button
            className={classes.editButton}
            onClick={handleEditClick}
            title={instantSurvey.editConfigurationTooltip}
          >
            <EditIcon style={{ fontSize: 18, color: '#5B65DC' }} />
          </Button>
        )}
      </div>
      <div className={classes.sectionContent}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className={classes.readOnlyLabel}>{instantSurvey.fieldAssessmentName}</div>
            <div className={classes.readOnlyField}>
              <div className={classes.readOnlyValue}>
                {currentSurvey?.title || instantSurvey.valueUntitledAssessment}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className={classes.readOnlyLabel}>{instantSurvey.fieldAssessmentType}</div>
            <div className={classes.readOnlyField}>
              <div className={classes.readOnlyValue}>
                {getSurveyTypeName(currentSurvey?.surveyType) || instantSurvey.valueTypeNotSpecified}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className={classes.readOnlyLabel}>{instantSurvey.fieldSurveyCode}</div>
            <div className={classes.readOnlyField}>
              <div className={classes.readOnlyValue}>
                {currentSurvey?.code || instantSurvey.valueNoCodeGenerated}
              </div>
            </div>
          </Grid>
        </Grid>

        {/* Additional read-only fields */}
        <Grid container spacing={2} style={{ marginTop: 16 }}>
          <Grid item xs={12} sm={6}>
            <div className={classes.readOnlyLabel}>{instantSurvey.fieldMaxSubmissions}</div>
            <div className={classes.readOnlyField}>
              <div className={classes.readOnlyValue}>
                {currentSurvey?.maxSubmissions || instantSurvey.valueUnlimited}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className={classes.readOnlyLabel}>{instantSurvey.fieldAnonymous}</div>
            <div className={classes.readOnlyField}>
              <div className={classes.readOnlyValue}>
                {currentSurvey?.isAnonymous ? instantSurvey.valueAllowed : instantSurvey.valueNotAllowed}
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default BasicConfigurationWidget;